import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { LearningPlanService } from "src/app/_services/learning-plan.service";
import { GetDigLitSelfAssessmentDataError, GetDigLitSelfAssessmentDataSuccess, 
	SaveDigLitSelfAssessment, 
	SaveDigLitSelfAssessmentError, 
	SaveDigLitSelfAssessmentSession, 
	SaveDigLitSelfAssessmentSessionError, 
	SaveDigLitSelfAssessmentSessionSuccess, 
	SaveDigLitSelfAssessmentSuccess, 
	SetDigLitStateSuccess } from "./dig-lit-self-assessment.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { DigLitSelfAssessmentResult } from "src/app/_models/DigitalLiteracy";
import { HttpErrorResponse } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { DigLitSelfAssessmentActionTypes } from "src/app/constants/StoreConstants";
import { Action } from "@ngrx/store";

@Injectable()
export class DigLitSelfAssessmentEffects {
	constructor(private action$: Actions,
		private learningPlanService: LearningPlanService){}

	public getDataEffect$ = createEffect(():Observable<Action> => {
		return this.action$.pipe(
			ofType(DigLitSelfAssessmentActionTypes.GetDigLitSelfAssessmentData),
			switchMap((payload: { learnerId: number }) =>
				this.learningPlanService.getDigLitSelfAssessment$(payload.learnerId).pipe(
					map((result: DigLitSelfAssessmentResult) => {
						return GetDigLitSelfAssessmentDataSuccess({result: result});
					}),
					catchError((error: HttpErrorResponse) => {
						return of(GetDigLitSelfAssessmentDataError({error: error}));
					})
				)
			)
		) 
	});

	public saveEffect$ = createEffect(() => {
		return this.action$.pipe(
			ofType(SaveDigLitSelfAssessment),
			switchMap((payload: { data: DigLitSelfAssessmentResult }) => 
				this.learningPlanService.saveDigLitSelfAssessment$(payload.data).pipe(
					map((result: boolean) => {
						return SaveDigLitSelfAssessmentSuccess({result: result});
					}),
					catchError((error: HttpErrorResponse) => {
						return of(SaveDigLitSelfAssessmentError({error: error}));
					})
				)
			)
		)
	});

	public saveSessionEffect$ = createEffect(() => {
		return this.action$.pipe(
			ofType(SaveDigLitSelfAssessmentSession),
			switchMap((payload: { data: DigLitSelfAssessmentResult }) => 
				this.learningPlanService.saveDigLitSelfAssessmentSession$(payload.data).pipe(
					map((result: boolean) => {
						return SaveDigLitSelfAssessmentSessionSuccess({result: result});
					}),
					catchError((error: HttpErrorResponse) => {
						return of(SaveDigLitSelfAssessmentSessionError({error: error}));
					})
				)
			)
		)
	});

	public setDigLitStateSuccess$ = createEffect(():Observable<Action> => {
		return this.action$.pipe(
				ofType(DigLitSelfAssessmentActionTypes.SetDigLitState),
				map(() => {
						return SetDigLitStateSuccess();
				})				
		)
	});
}